import { useMemo } from 'react';

/**
 * Hook personalizado para obtener imágenes según el género del usuario
 * @param {string} genero - 'M' para masculino, 'F' para femenino
 * @returns {function} Función que retorna la ruta de la imagen con el sufijo correcto
 */
export const useGenderImages = (genero) => {
  const getImage = useMemo(() => {
    const suffix = genero === 'F' ? 'woman' : '';
    console.log('useGenderImages - Género:', genero, '| Sufijo:', suffix);
    
    return (baseName, folder = 'menu') => {
      const path = `/assets/${folder}/${baseName}${suffix}.png`;
      console.log('Imagen generada:', path);
      return path;
    };
  }, [genero]);

  return getImage;
};

export default useGenderImages;
